export default "__VITE_PUBLIC_ASSET__1cc200dd__"